/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { get_todays_leave_report } from '../api/widgetApi';
import { KTIcon } from '../../../helpers';
import { Dropdown1 } from '../../content/dropdown/Dropdown1';

type Props = {
  className: string;
};

const ListsWidget2: React.FC<Props> = ({ className }) => {
  const [todaysLeavesList, setTodaysLeavesList] = useState([]);
  const { data: todaysLeaves, isLoading, error } = useQuery('todaysLeaves', get_todays_leave_report, {
    refetchOnWindowFocus: false,
  });
  useEffect(() => {
    if (todaysLeaves) {
      setTodaysLeavesList(todaysLeaves.data);
    }
  }, [todaysLeaves]);
console.log("todaysLeavesList",todaysLeavesList)
  if (isLoading) {
    return (
      <div className="text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return <div className="text-center text-danger">Error loading today's leave report</div>;
  }

  return (
    <div className={`card ${className}`}>
      {/* begin::Header */}
      <div className="card-header mt-5 border-0 d-flex justify-content-between align-items-center">
        <h3 className="card-title fw-bold text-dark">Today's Leave Reports</h3>
        <div className="card-toolbar">
          {/* begin::Menu */}
          <button
            type="button"
            className="btn btn-sm btn-icon btn-color-primary btn-active-light-primary"
            data-kt-menu-trigger="click"
            data-kt-menu-placement="bottom-end"
            data-kt-menu-flip="top-end"
          >
            <KTIcon iconName="setting-4" className="fs-2" />
          </button>
          <Dropdown1 />
          {/* end::Menu */}
        </div>
      </div>
      {/* end::Header */}
      {/* begin::Body */}
      
      {/* end::Body */}
    </div>
  );
};

export { ListsWidget2 };
